import React from "react";
import { ToastNotification } from "carbon-components-react";
import "./toastNotification.scss";

export const Toast = (props) => {
  const { status, message, title } = props;
  return (
    <ToastNotification
      hideCloseButton={true}
      size="small"
      kind={status}
      title={title}
      timeout={4000}
      subtitle={message}
    />
  );
};
